/**
 * URL to the article css.
 *
 * This comes from `public/css/article/#version#` and is published to
 * staticfiles.dixa.io by the knowledge-article-css workflow. There is no
 * staging copy, the version in the path keeps changes apart.
 *
 * The no rems option is for the agent interface as they don't currently have
 * the root fontsize set.
 */
export function articleCssCDN({
  cssVersion = '1.3.0',
  noREMs = false,
}: {
  cssVersion?: string;
  noREMs?: boolean;
} = {}): string {
  // use newer css files.
  const _cssVersion =
    cssVersion === '1.0.0' || cssVersion === '1.1.0' ? '1.3.0' : cssVersion;
  const filename = noREMs ? 'article-no-rems.css' : 'article.css';

  return `https://staticfiles.dixa.io/knowledge/css/article/${_cssVersion}/${filename}`;
}
